import React from 'react';

export default function ServiceCard({ img, title, desc, options }) {
  return (
    <article className='am-service-card' aria-labelledby={`svc-${title}-title`}>
      <div className='am-service-card-inner'>
        <div className='am-service-image-wrap'>
          <div className='am-service-image-circle'>
            <img src={img} alt={title.replace('\n', ' ')} />
          </div>
        </div>

        <h4 id={`svc-${title}-title`} className='am-service-title'>
          {title.split('\n').map((line, idx) => (
            <span key={idx} className='service-title-line'>
              {line}
            </span>
          ))}
        </h4>

        <p className='am-service-desc'>{desc}</p>

        {/* per-service options (appear on hover) */}
        <div className='am-service-options' aria-hidden='true'>
          {options &&
            options.map((opt, idx) => {
              const optLower = String(opt).toLowerCase();
              const isHomeMaintenance = optLower.includes('home');
              const isCondo = optLower.includes('condo');
              const isHouse = optLower.includes('house');
              const isOffice = optLower.includes('office') || optLower.includes('store');

              if (isHomeMaintenance) {
                return (
                  <a key={idx} className='am-service-option' href='/home-maintenance'>
                    {opt}
                  </a>
                );
              } else if (isCondo) {
                return (
                  <a key={idx} className='am-service-option' href='/condo-cleaning'>
                    {opt}
                  </a>
                );
              } else if (isHouse) {
                return (
                  <a key={idx} className='am-service-option' href='/house-cleaning'>
                    {opt}
                  </a>
                );
              } else if (isOffice) {
                return (
                  <a key={idx} className='am-service-option' href='/office-cleaning'>
                    {opt}
                  </a>
                );
              } else {
                return (
                  <button key={idx} className='am-service-option'>
                    {opt}
                  </button>
                );
              }
            })}
        </div>

        <button className='am-service-arrow' aria-label={`Explore ${title.replace('\n', ' ')}`}>
          ›
        </button>
      </div>
    </article>
  );
}
